<app-navbar appHideBreadcrumb>
    <h2>Interviurile mele</h2>
</app-navbar>


<div class="container" *ngIf="interviewsLoaded">
    <div class="view-applications-container">
        <div class="view-application-inner">
            <div class="row">
                <div class="col-12 mb-5">

                </div>
            </div>
        </div>
    </div>
</div>

<app-footer>
</app-footer>